import styles from './home.module.scss';
import { useEffect, useReducer, useState } from 'react';
import { WSkeleton } from '../../components/wrappers/wrapper';
import InfiniteScroll from 'react-infinite-scroll-component';
import { WArticle } from '../../components/prefabs/article/article';
import dbService from '../../services/database.service';
import { IPaginate, TArticle } from '../../models/common';
import useArticle from 'custom-hooks/useArticle';

function HomePage() {
  const { articles, setArticles, deleteArticle } = useArticle();

  const [hasMore, setHasMore] = useState(true);
  const [, forceUpdate] = useReducer((x) => x + 1, 0);

  const fetchArticles = () => {
    dbService
      .getArticles({
        paginate: true,
        skip: articles.length,
        limit: 12,
        relation: true,
        sort: { likes_count: -1 },
        filter: { is_documentation: false }
      })
      .then((res) => {
        const resPaginate = res as unknown as IPaginate<TArticle>;
        const shuffledArray = resPaginate.data.sort(() => Math.random() - 0.5);
        const newArticlesArray = articles.concat(shuffledArray);
        setArticles(newArticlesArray);
        setHasMore(newArticlesArray.length < resPaginate.meta.total);
      });
  };

  useEffect(() => {
    fetchArticles();
  }, []);

  const handleDeleteArticle = (id: string) => {
    deleteArticle(id).then(() => forceUpdate());
  };

  return (
    <InfiniteScroll
      dataLength={articles.length}
      next={fetchArticles}
      hasMore={hasMore}
      loader={
        <div className={styles.skeleton}>
          <WSkeleton variant="rounded" height={335}></WSkeleton>
          <WSkeleton variant="rounded" height={335}></WSkeleton>
        </div>
      }
      height={'var(--acticles-content-height)'}
      className={styles.home}
      endMessage={
        <p style={{ textAlign: 'center' }}>
          <b>You have seen it all</b>
        </p>
      }
    >
      {articles.map((article, index) => {
        return (
          <div className={styles.article} key={index}>
            <WArticle
              onDelete={handleDeleteArticle}
              data={article}
              key={article._id}
              type="content"
            />
          </div>
        );
      })}
    </InfiniteScroll>
  );
}

export default HomePage;
